import Logo from "../assets/Library.svg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div>
        <div className="container">
          <div className="row row__column">
            <Link to="/">
              <figure className="footer__logo">
                <img src={Logo} className="footer__logo--img" alt="" />
              </figure>
            </Link>
            <div className="footer__list">
              <Link to="/" className="footer__link">
                Home
              </Link>
              <Link to="/" className="footer__link no-cursor">
                About
              </Link>
              <Link to="/books" className="footer__link">
                Books
              </Link>
              <Link to="/cart" className="footer__link">
                Cart
              </Link>
              <div className="footer__copyright">
                &copy; 2024 Library. All rights reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
